import { hashString } from './hashString';
export const createUniqueClassName = (filepath, elementName) => {
    var _a;
    const hash = hashString(filepath);
    const filename = (_a = filepath === null || filepath === void 0 ? void 0 : filepath.split('/').pop()) === null || _a === void 0 ? void 0 : _a.split('.').shift();
    return `${filename}__${elementName}-${Math.abs(hash)}`;
};
//# sourceMappingURL=createUniqueClassName.js.map
